import Vue from "vue";
import VueRouter from "vue-router";

if (process.env.NODE_ENV === "development") {
    Vue.use(VueRouter);
}

import { ROUTER_MODE } from "../config/app";

import Home from "../views/home/index.vue";

// 管理组相关
import adminRouter from "../views/userManage/admin/router.vue";
import authAdmin from "../views/userManage/admin/authAdmin.vue";
import authRole from "../views/userManage/admin/authRole.vue";
import authPermissionRule from "../views/userManage/admin/authPermissionRule.vue";
import MenuManagement from "../views/userManage/MenuManagement/MenuManagement.vue";

// 信息发布
import NoticeAdministration from "../views/components/NoticeAdministration.vue";
// 合同管理
import ContractManagement from "../views/components/ContractManagement/ContractManagement.vue";
import ContractManagementOcenter from "../views/components/ContractManagement/ContractManagementOcenter.vue";
// 场地管理
import SiteManagement from "../views/components/SiteManagement/SiteManagement.vue";
// 预约管理
import BookingManagement from "../views/components/BookingManagement/BookingManagement.vue";
// 枚举管理
import EnumerationManagement from "../views/components/EnumerationManagement/EnumerationManagement.vue";
// 租户管理
import CompanyManagement from "../views/components/CompanyManagement/CompanyManagement.vue";
import UserManagement from "../views/components/UserManagement/UserManagement.vue";
// 报事报修
import ReportRepair from "../views/components/ReportRepair/ReportRepair.vue";
// 优惠管理
import PreferentialManagement from "../views/components/PreferentialManagement/PreferentialManagement.vue";
// 意见反馈
import ComplaintProposalPraise from "../views/components/ComplaintProposalPraise/ComplaintProposalPraise.vue";
// 门禁管理
import AccessControl from "../views/components/AccessControl/AccessControl.vue";
// 门禁卡管理
import AccessControlCard from "../views/components/AccessControlCard/AccessControlCard.vue";
// 访客管理
import Auditvisitors from "../views/components/Auditvisitors/Auditvisitors.vue";
// 加班登记
import OvertimeRegistration from "../views/components/OvertimeRegistration/OvertimeRegistration.vue";

// 满意度调研
import SatisfactionSurveySet from "../views/components/SatisfactionSurveySet/SatisfactionSurveySet.vue";
import SatisfactionSurvey from "../views/components/SatisfactionSurvey/SatisfactionSurvey.vue";
import SatisfactionSurveyTemplate from "../views/components/SatisfactionSurveyTemplate/SatisfactionSurveyTemplate.vue";
// 企业服务管理
import EnterpriseServices from "../views/components/EnterpriseServices/EnterpriseServices.vue";
// 报表
import ReportFormFinance from "../views/components/ReportFormFinance/ReportFormFinance.vue";
import ExpenseBill from "../views/components/ExpenseBill/ExpenseBill.vue";
import HydropowerExpenseBill from "../views/components/ExpenseBill/HydropowerExpenseBill.vue";
// 日常巡检
import Inspection from "../views/components/Inspection/Inspection.vue";
// 部门管理
import Department from "../views/components/Department/Department.vue";
// 广告管理
import adSite from "../views/adManage/adSite.vue";
import ad from "../views/adManage/ad.vue";

// Vue.use(VueRouter);

const err401 = r =>
    require.ensure([], () => r(require("../views/error/err401.vue")), "home");
const err404 = r =>
    require.ensure([], () => r(require("../views/error/err404.vue")), "home");
const login = r =>
    require.ensure([], () => r(require("../views/login/index.vue")), "home");
const main = r =>
    require.ensure([], () => r(require("../views/home/main.vue")), "home");

// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [
    {
        path: "*",
        component: err404,
        hidden: true
    },
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err404,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "登录",
        hidden: true
    },
    {
        path: "/",
        component: Home,
        redirect: "/readme",
        name: "首页",
        hidden: true
    },
    {
        path: "/readme",
        component: Home,
        redirect: "/readme/main",
        icon: "shouye",
        name: "控制台",
        noDropdown: true,
        children: [
            {
                path: "main",
                component: main
            }
        ]
    },
    {
        path: "/components",
        redirect: "/components/NoticeAdministration",
        component: Home,
        name: "信息管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "NoticeAdministration",
                component: NoticeAdministration
            }
        ]
    },
    // ContractManagement
    {
        path: "/ContractManagement",
        redirect: "/ContractManagement/index",
        component: Home,
        name: "合同管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "ContractManagementOcenter",
                name: "Ocenter合同",
                component: ContractManagementOcenter
            },
            {
                path: "ContractManagement",
                name: "其他合同",
                component: ContractManagement
            }
        ]
    },
    {
        path: "/SiteManagement",
        redirect: "/SiteManagement/index",
        component: Home,
        name: "场地管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: SiteManagement
            }
        ]
    },
    {
        path: "/BookingManagement",
        redirect: "/BookingManagement/index",
        component: Home,
        name: "预约管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: BookingManagement
            }
        ]
    },
    {
        path: "/TenantManagement",
        redirect: "/TenantManagement/CompanyManagement",
        component: Home,
        name: "租户管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "CompanyManagement",
                name: "公司管理",
                component: CompanyManagement
            },
            {
                path: "UserManagement",
                name: "客户管理",
                component: UserManagement
            }
        ]
    },
    {
        path: "/EnumerationManagement",
        redirect: "/EnumerationManagement/index",
        component: Home,
        name: "枚举管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: EnumerationManagement
            }
        ]
    },
    {
        path: "/ReportRepair",
        redirect: "/ReportRepair/index",
        component: Home,
        name: "报事报修",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                name: "报事报修",
                component: ReportRepair
            }
        ]
    },
    {
        path: "/ComplaintProposalPraise",
        redirect: "/ComplaintProposalPraise/index",
        component: Home,
        name: "意见反馈",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: ComplaintProposalPraise
            }
        ]
    },
    {
        path: "/PreferentialManagement",
        redirect: "/PreferentialManagement/index",
        component: Home,
        name: "优惠管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: PreferentialManagement
            }
        ]
    },
    {
        path: "/AccessControl",
        redirect: "/AccessControl/index",
        component: Home,
        name: "门禁管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: AccessControl
            }
        ]
    },
    {
        path: "/AccessControlCard",
        redirect: "/AccessControlCard/index",
        component: Home,
        name: "门禁卡管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: AccessControlCard
            }
        ]
    },
    {
        path: "/Auditvisitors",
        redirect: "/Auditvisitors/index",
        component: Home,
        name: "访客管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: Auditvisitors
            }
        ]
    },
    {
        path: "/OvertimeRegistration",
        redirect: "/OvertimeRegistration/index",
        component: Home,
        name: "加班登记",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: OvertimeRegistration
            }
        ]
    },
    {
        path: "/SatisfactionSurvey",
        redirect: "/SatisfactionSurvey/index",
        component: Home,
        name: "满意度调研管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "SatisfactionSurveySet",
                name: "满意度调研设置",
                component: SatisfactionSurveySet
            },
            {
                path: "SatisfactionSurvey",
                name: "满意度调研",
                component: SatisfactionSurvey
            },
            {
                path: "SatisfactionSurveyTemplate",
                name: "满意度调研模板",
                component: SatisfactionSurveyTemplate
            }
        ]
    },
    {
        path: "/ReportForm",
        redirect: "/ReportForm/index",
        component: Home,
        name: "报表管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "ReportFormFinance",
                name: "财务报表",
                component: ReportFormFinance
                // component: ExpenseBill
            },
            {
                path: "ExpenseBill",
                name: "租金物业费",
                component: ExpenseBill
            },
            {
                path: "HydropowerExpenseBill",
                name: "其他收费",
                component: HydropowerExpenseBill
            },
            {
                path: "ReportRepairAccount",
                name: "报事报修台账",
                component: () =>
                    import("@/views/components/ReportRepair/ReportRepairAccount.vue")
            },
            {
                path: "ComplaintProposalPraiseAccount",
                name: "投诉建议台账",
                component: () =>
                    import("@/views/components/ComplaintProposalPraise/ComplaintProposalPraiseAccount.vue")
            }
        ]
    },
    {
        path: "/Inspection",
        redirect: "/Inspection/index",
        component: Home,
        name: "日常巡检",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: Inspection
            }
        ]
    },
    {
        path: "/EnterpriseServices",
        redirect: "/EnterpriseServices/index",
        component: Home,
        name: "企业服务管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: EnterpriseServices
            }
        ]
    },
    {
        path: "/Department",
        redirect: "/Department/index",
        component: Home,
        name: "部门管理",
        icon: "tongyong",
        noDropdown: true,
        children: [
            {
                path: "index",
                component: Department
            }
        ]
    }
];

const router = new VueRouter({
    // mode: history, //后端支持可开
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    strict: process.env.NODE_ENV !== "production"
});
router.beforeEach((to, form, next) => {
    // console.log(to, form);
    next();
});
export default router;
export const asyncRouterMap = [
    {
        path: "/userManage",
        redirect: "/userManage/adminManage/index",
        component: Home,
        icon: "guanliyuan1",
        name: "用户管理",
        meta: {
            authRule: ["user_manage"]
        },
        // noDropdown: true,
        children: [
            {
                path: "/userManage/adminManage",
                component: adminRouter,
                redirect: "/userManage/authAdmin/index",
                name: "管理组",
                icon: "",
                meta: {
                    authRule: ["user_manage/admin_manage"]
                },
                children: [
                    {
                        path: "authAdmin",
                        component: authAdmin,
                        name: "管理员管理",
                        icon: "",
                        meta: {
                            authRule: ["admin/auth.admin/index"]
                        }
                    },
                    {
                        path: "authRole",
                        component: authRole,
                        name: "角色管理",
                        icon: "",
                        meta: {
                            authRule: ["admin/auth.role/index"]
                        }
                    },
                    {
                        path: "authPermissionRule",
                        component: authPermissionRule,
                        name: "权限管理",
                        icon: "",
                        meta: {
                            authRule: ["admin/auth.permission_rule/index"]
                        }
                    },
                    {
                        path: "MenuManagement",
                        component: MenuManagement,
                        name: "菜单管理",
                        icon: "",
                        meta: {
                            authRule: ["admin/auth.permission_rule/index"]
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/adManage",
        redirect: "/adManage/adSite",
        component: Home,
        icon: "guanggao",
        name: "广告相关",
        meta: {
            authRule: ["ad_manage"]
        },
        // noDropdown: true,
        children: [
            {
                path: "adSite",
                component: adSite,
                name: "广告位管理",
                icon: "",
                meta: {
                    authRule: ["admin/ad.site/index"]
                }
            },
            {
                path: "ad",
                component: ad,
                name: "广告管理",
                icon: "",
                meta: {
                    authRule: ["admin/ad.ad/index"]
                }
            }
        ]
    }
];
